module.exports = __webpack_public_path__ + "img/Cards.409a1d83.png";